// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"065ef0eb","937":"a54d6da7"}[chunkId] + ".chunk.js";
};